import {lazy} from 'react';

const loadUserPage = () => import('./UserPage');
export const UserPageLoad = lazy(loadUserPage);

const loadTracePage = () => import('./TracePage');
export const TracePageLoad = lazy(loadTracePage);

const loadPermissionsRolesPage = () => import('./PermissionsRolesPage');
export const PermissionsRolesPageLoad = lazy(loadPermissionsRolesPage);

const loadPermissionsRolesFormPage = () => import('./PermissionsRolesFormPage');
export const PermissionsRolesFormPageLoad = lazy(loadPermissionsRolesFormPage);

const loadProfilePage = () => import('./ProfilePage');
export const ProfilePageLoad = lazy(loadProfilePage);

const loadUserDetailsPage = () => import('./UserDetailsPage');
export const UserDetailsPageLoad = lazy(loadUserDetailsPage);

